"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Product_module_1 = tslib_1.__importDefault(require("./modules/Product.module"));
const loadRelatedCategoriesModule = initialData => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData)],
});
exports.default = loadRelatedCategoriesModule;
